import moment from 'moment';

export default {
  data() {
    return {
      sidebarVisible: false,
      columnVisibility: [],
      filterColumns: {},
      showSidebar: false,
      loader: false,
      is_active: 'active',
      exportLoader: false,
      totalCount: 0,
      currentPage: 1,
      perPage: 100,
      users: [],
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      reports: [],
      searchUser: [],
      IsCurrentPageOne: false,
      isSchedularModalOpen: false,
      activeBtn: (this.$route.query && this.$route.query.active) || null,
      payload: {},
      manage_by_users: [],
      reporting_to_users: [],
      dynamicFields: [],
      manage_by: [],
      reporting_to: [],
    };
  },
  computed: {
    scheduleFilter() {
      return {
        member: this.searchUser || [],
        date: `${this.startDate} to ${this.endDate}` || null,
      };
    },
    filterUserOptions() {
      return this.sortedUser(this.users);
    },
  },

  watch: {
    currentPage(val) {
      if (val) this.clockTimeSheetReport();
    },
    perPage() {
      if (this.currentPage === 1) {
        this.clockTimeSheetReport();
      } else {
        this.currentPage = 1;
      }
    },
    is_active() {
      this.userList();
    },

    filterColumns: {
      deep: true,
      handler() {
        this.buildDynamicFields();
      },
    },
  },

  mounted() {
    const queryParams = this.$route.query;
    if (queryParams && Object.keys(queryParams).length > 0) {
      if (queryParams.is_active) this.is_active = queryParams.is_active;
      if (queryParams.searchUser) this.searchUser = queryParams.searchUser.split(',').filter(Boolean);
      if (queryParams.manage_by) this.manage_by = queryParams.manage_by.split(',').filter(Boolean);
      if (queryParams.reporting_to) this.reporting_to = queryParams.reporting_to.split(',').filter(Boolean);
      if (queryParams.startDate) this.startDate = queryParams.startDate;
      if (queryParams.endDate) this.endDate = queryParams.endDate;
      if (queryParams.active) this.activeBtn = queryParams.active;
      if (queryParams.currentPage) this.currentPage = Number(queryParams.currentPage);
      if (queryParams.perPage) this.perPage = Number(queryParams.perPage);
    }
    this.clockTimeSheetReport();
    this.filterFunctionCallFromMixin();
    const storedFilters = localStorage.getItem('clock_timesheet_filter_columns');
    if (storedFilters) {
      this.filterColumns = JSON.parse(storedFilters);
      this.buildDynamicFields();
    } else {
      this.loadFilterColumns();
    }
  },
  methods: {
    resetFilterState() {
      this.currentPage = 1;
      this.perPage = 100;
      this.manage_by = [];
      this.reporting_to = [];
      this.searchUser = [];
      this.startDate = moment().format('YYYY-MM-DD');
      this.endDate = moment().format('YYYY-MM-DD');
      this.is_active = 'active';
      this.activeBtn = null;
    },

    getQueryParams() {
      const queryParams = {
        is_active: this.is_active !== 'active' ? this.is_active : null,
        searchUser: this.searchUser,
        manage_by: this.manage_by,
        reporting_to: this.reporting_to,
        startDate: this.startDate !== moment().format('YYYY-MM-DD') ? this.startDate : null,
        endDate: this.endDate !== moment().format('YYYY-MM-DD') ? this.endDate : null,
        active: this.activeBtn,
        currentPage: this.currentPage !== 1 ? this.currentPage : null,
        perPage: this.perPage !== 100 ? this.perPage : null,
      };

      return Object.keys(queryParams).reduce((acc, key) => {
        if (Array.isArray(queryParams[key]) && queryParams[key].length > 0) {
          acc[key] = queryParams[key].join(',');
        } else if (queryParams[key] && !Array.isArray(queryParams[key])) {
          acc[key] = queryParams[key];
        }
        return acc;
      }, {});
    },

    updateQueryParams() {
      const query = this.getQueryParams();
      this.routeQueryUpdate(query);
    },

     /* user List */
     async userList() {
      const input = {
        sort_field: 'name',
        sort_order: 'asc',
        is_active: this.is_active && this.is_active !== 'all_data'
          ? this.is_active === 'active'
          : '',
      }
      const response = await this.getHTTPPostResponse(
        'admin/master/user/active-inactive-userlist',
        input,
        false,
      )
      if (response && response.data) {
        const { data } = response
        this.users = data.users
      }
    },
    closeSidebar() {
      this.showSidebar = false;
    },
    /**
     * Load filter columns
     */
    async loadFilterColumns() {
      const storedFilters = localStorage.getItem('clock_timesheet_filter_columns');
      if (storedFilters) {
        this.filterColumns = JSON.parse(storedFilters);
      } else {
        const response = await this.getHTTPGetResponse('clock-timesheet-report/list-filters');
        if (response?.status === 200) {
          this.filterColumns = response.data;
          localStorage.setItem('clock_timesheet_filter_columns', JSON.stringify(this.filterColumns));
        }
      }
      this.buildDynamicFields();
    },

    /**
     * Save column filters
     */
    async saveColumnFilters() {
      this.loader = true;
      try {
        const payload = { show_columns: this.filterColumns };
        const response = await this.getHTTPPostResponse('clock-timesheet-report/save-filter', payload, false);

        if (response?.status === 200) {
          this.filterColumns = response.data;
          localStorage.setItem('clock_timesheet_filter_columns', JSON.stringify(response.data));
          this.buildDynamicFields();
          this.showSidebar = false;
        }
      } catch (error) {
        console.error('Failed to save filter columns:', error);
      } finally {
        this.loader = false;
      }
    },

    /**
     * Build dynamic fields
     */
    buildDynamicFields() {
      this.dynamicFields = Object.entries(this.filterColumns)
        .filter(([_, isVisible]) => isVisible)
        .map(([key]) => ({
          key,
          label: this.convertToLabel(key),
          sortable: false,
        }));

      this.dynamicFields.unshift({
        key: 'action',
        label: ' ',
        sortable: false,
        with:'30px',
        thStyle: { minWidth: '10px', maxWidth: '10px' },
        tdStyle: { minWidth: '0px' },
        tdClass: 'text-right',
      });
    },

    /**
     * Convert to uppercase label
     */
    convertToLabel(key) {
      return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    },

    /**
     * Show all columns
     */
    showAllColumns() {
      Object.keys(this.filterColumns).forEach(key => {
        this.filterColumns[key] = true;
      });
    },
    async filterFunctionCallFromMixin() {
      if (this.$store.state.app.manageByUsersList.length == 0) {
        this.manage_by_users = await this.manageByUserList();
      } else {
        this.manage_by_users = this.$store.state.app.manageByUsersList;
      }

      if (this.$store.state.app.reportingUserList.length == 0) {
        this.reporting_to_users = await this.reportingtoUserList();
      } else {
        this.reporting_to_users = this.$store.state.app.reportingUserList;
      }
      this.userList();
    },
    updateDate(obj) {
      this.startDate = obj?.startDate || null;
      this.endDate = obj?.endDate || null;
      this.activeBtn = obj?.active || null;
      this.IsCurrentPageOne = true;
      this.clockTimeSheetReport();
    },
    applyFilter() {
      if (this.currentPage !== 1 && this.IsCurrentPageOne) {
        this.currentPage = 1;
      } else {
        this.clockTimeSheetReport();
      }
    },

    /**
     * Clear filter
     */
    clearFilter() {
      this.resetFilterState();
      this.reports = [];
      this.applyFilter();
    },

    /**
     * Get Clock timesheet report data
     */
    async clockTimeSheetReport() {
      this.loader = true;
      this.updateQueryParams();

      const input = {
        page: this.currentPage,
        per_page: this.perPage,
        start_date: this.startDate,
        end_date: this.endDate,
        member: this.searchUser,
        is_active: this.is_active && this.is_active !== 'all_data'
          ? this.is_active === 'active'
          : '',
        manage_by: this.manage_by,
        reporting_to: this.reporting_to,
      };

      this.payload = input;

      const response = await this.getHTTPPostResponse('clock-timesheet-report', input, false);

      if (response?.status === 200) {
        const { data } = response;
        this.totalCount = data.count;
        this.reports = data.users;
      }
      this.loader = false;
    },
    
    confirmationFunction(type) {
      const isAdmin = this.userInfo.role === 'SA' || this.userInfo.is_resource_managing;

      const htmlContent = isAdmin
        ? `
          <p class='my-1'>Are you sure you want to export?</p>
          <div class='d-flex justify-content-center'>
            <div class='d-flex justify-content-center align-items-center'>
              <input type="radio" id="export_all" name="export_option" value="all" class="input-aleart" />
              <label for="export_all" class='label-sweet mb-0'> All Columns </label>
            </div>
            <div class='d-flex justify-content-center align-items-center ml-2'>
              <input type="radio" id="export_visible" name="export_option" value="visible" checked class="input-aleart" />
              <label for="export_visible" class='label-sweet mb-0'> Filtered Columns </label>
            </div>
          </div>
        `
        : `<p class='my-1'>Are you sure you want to export?</p>`;

      this.$swal({
        title: 'Note',
        html: htmlContent,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn confirm',
          cancelButton: 'btn cancel ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          let isAllColumns = false;
          if (isAdmin) {
            const selected = document.querySelector('input[name="export_option"]:checked')?.value;
            isAllColumns = selected === 'all';
          }
          this.generateExportReport(isAllColumns, type);
        }
      });
    },

    /**
     * Generate export report
     */
    async generateExportReport(isAllColumns, fileType) {
      this.exportLoader = true;

      const queryParams = new URLSearchParams();
      queryParams.append('is_visible', isAllColumns ? 0 : 1);
      queryParams.append('export_type', fileType);

      const payload = { ...this.payload };
      delete payload.page;
      delete payload.per_page;
      const arrayParams = ['member', 'reporting_to', 'manage_by', 'start_date', 'end_date'];

      arrayParams.forEach(param => {
        if (Array.isArray(payload[param]) && payload[param].length) {
          payload[param].forEach(value => queryParams.append(`${param}[]`, value));
        }
        else if (payload[param]) {
          queryParams.append(param, payload[param]);
        }
      });

      const baseURL = `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_API_VERSION}/clock-timesheet-report`;
      const finalURL = `${baseURL}?${queryParams.toString()}`;
      const fileName = fileType === 'PDF' ? 'ClockTimeSheet.pdf' : `ClockTimeSheet.${fileType.toLowerCase()}`;

      try {
        const response = await this.$axios({
          url: finalURL,
          method: 'POST',
          responseType: 'blob',
        });

        const blob = new Blob([response.data], {
          type: fileType === 'PDF' ? 'application/pdf' : 'text/csv;charset=utf-8;',
        });

        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.error('Export failed', err);
      } finally {
        this.exportLoader = false;
      }
    },

    closeDropdown() {
      this.showSidebar = false;
    },

    back() {
      this.$router.back();
    },
  },
};
